import { render, staticRenderFns } from "./babyFeed.vue?vue&type=template&id=35bc70aa&scoped=true"
import script from "./babyFeed.vue?vue&type=script&lang=js"
export * from "./babyFeed.vue?vue&type=script&lang=js"
import style0 from "./babyFeed.vue?vue&type=style&index=0&id=35bc70aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc70aa",
  null
  
)

export default component.exports